import { render, staticRenderFns } from "./Exam-hall.vue?vue&type=template&id=ae5691ee&scoped=true"
import script from "./Exam-hall.vue?vue&type=script&lang=js"
export * from "./Exam-hall.vue?vue&type=script&lang=js"
import style0 from "./Exam-hall.vue?vue&type=style&index=0&id=ae5691ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5691ee",
  null
  
)

export default component.exports